import { render, staticRenderFns } from "./strategy.vue?vue&type=template&id=97bec0b0&"
import script from "./strategy.vue?vue&type=script&lang=js&"
export * from "./strategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports